// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"262":"995b6400","897":"e167844e"}[chunkId] + ".css";
};